import { useEffect, useRef } from 'react'

export function useCustomEventListener<T>(
  eventName: string,
  callback: (event: CustomEvent<T>) => void,
) {
  const callbackRef = useRef(callback)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const handler = (event: Event) => {
      callbackRef.current(event as CustomEvent<T>)
    }

    window.addEventListener(eventName, handler as EventListener)
    return () => {
      window.removeEventListener(eventName, handler as EventListener)
    }
  }, [eventName])
}
